import React, { useEffect, useRef } from 'react'
import { INavItem } from 'New/feed-static/components/top-nav'
import { useRouter } from 'next/router'
import { scrollToWithStickyObserve } from 'Components/hooks/use-scroll-sticky-observe'
import StickyHeader from 'Components/new/scroll-sticky/sticky-header'
import OverflowTooltip from 'Components/new/overflow-tooltip'
import classNames from 'classnames'
import { headerHeight } from 'Components/new-header'
import Link from 'next/link'
import style from './index.module.scss'
import serializeObject from '@arsenal/arsenal/modules/serializeObject'

export const defaultNavList: INavItem[] = [
  {
    label: '推荐',
    path: '',
    title: '推荐资讯视频_资讯视频_懂车帝',
    keywords: '推荐资讯视频,资讯视频',
    description:
      '懂车帝提供推荐资讯视频,资讯视频,这里提供最新最全的汽车资讯,汽车行情,汽车科技新闻,汽车文化,试驾测评与车展赛事等汽车信息。',
  },
  // todo
  {
    label: '最新',
    reqLabel: '热点资讯',
    path: 'news',
    title: '最新汽车视频资讯_资讯视频_懂车帝',
    keywords: '最新汽车资讯,最新汽车,汽车资讯视频',
    description:
      '懂车帝视频资讯频道提供最新最全的汽车资讯,汽车行情,汽车科技新闻,汽车文化,试驾测评,用车知识,热点活动与车展赛事等汽车信息。',
  },
  {
    label: '新车',
    path: 'newcar',
    showHome: true,
    title: '汽车资讯大全_最新汽车资讯_新车资讯圈视频_懂车帝',
    keywords: '汽车资讯大全,最新汽车资讯,新车资讯圈视频',
    description:
      '懂车帝新车资讯视频频道为您提供最新最全的新车资讯,新车行情,新车科技新闻,新车文化,新车试驾测评,新车用车知识,热点活动与车展赛事等汽车信息，想了解新车相关内容，就上懂车帝新车频道！',
  },
  {
    label: '导购',
    path: 'guide',
    showHome: true,
    title: '新车导购_购车指南_车型海选视频_懂车帝',
    keywords: '新车导购,购车指南,车型海选视频',
    description:
      '懂车帝汽车导购视频频道，为您提供最新最全的汽车导购信息，包括车型海选，对比选购，购车指南，新车导购，汽车导购等信息。更多有关汽车导购信息尽在懂车帝。',
  },
  {
    label: '行业',
    path: 'industry',
    title: '最新汽车行业资讯视频_懂车帝',
    keywords: '汽车行业资讯,最新汽车行业资讯视频',
    description:
      '懂车帝汽车行业视频资讯频道提供最新最全的行业汽车资讯,汽车行情,汽车科技新闻,汽车文化,试驾测评,汽车行业数据等汽车信息，想了解更多汽车行业资讯就上懂车帝。',
  },
  {
    label: '摩托车',
    path: 'motor',
    title: '摩托车大全_摩托车图片_摩托车视频_摩托车价格视频_懂车帝',
    keywords: '摩托车大全,摩托车图片,摩托车视频,摩托车价格有哪些视频',
    description:
      '懂车帝摩托车视频频道为摩托车友提供最新摩托车资讯、摩托车专业评测、摩托车赛事活动报道、摩托车图片、摩托车视频，尽在懂车帝摩托车频道。',
  },
  // {
  //   label: '中国品牌',
  //   path: 'china',
  //   title: '中国品牌汽车_中国品牌汽车图片_中国品牌汽车价格_懂车帝',
  //   keywords: '中国品牌汽车,中国品牌汽车图片,中国品牌汽车价格',
  //   description: '懂车帝中国品牌汽车频道为国内车友提供最新中国品牌汽车资讯、中国品牌汽车专业评测、中国品牌汽车价格报道、中国品牌汽车图片、中国品牌汽车视频等信息，关注精彩纷呈中国品牌信息，尽在懂车帝。'
  // },
  {
    label: '用车',
    showHome: true,
    path: 'usage',
    title: '用车中心_用车服务_用车工具_用车知识视频_懂车帝',
    keywords: '用车中心,用车服务,用车工具,用车知识视频',
    description:
      '懂车帝用车中心视频频道,为您提供用车报价信息,涵盖汽车用品网上超市批发图片和价格，用车知识，用车百科，让你买到性价比最高的汽车用品与服务，就来懂车帝。',
  },
  {
    label: '车辆评测',
    reqLabel: '车辆评测',
    showHome: true,
    path: 'evaluating',
    title: '汽车评测_新车试驾_评测资讯视频_懂车帝',
    keywords: '汽车评测,新车试驾,评测资讯视频',
    description:
      '懂车帝车辆测评视频频道为您提供最专业全面汽车试驾评测报告,包含市区路况、郊外长途、山区、不同气温下汽车评测试驾体验报告,买车先读汽车试驾报告登陆懂车帝。',
  },
  {
    label: '提车作业',
    showHome: true,
    path: 'tiche',
    title: '提车作业大全_提车作业注意事项_提车作业图片视频_懂车帝',
    keywords: '提车作业大全,提车作业注意事项,提车作业图片视频',
    description:
      '懂车帝提车作业视频频道为您全面提供提车作业大全，这里汇集提车作业注意事项、提车作业图片等内容，想了解更多提车作业信息，就来懂车帝提车作业频道。',
  },
  {
    label: '自驾游',
    showHome: true,
    path: 'travel',
    title: '旅游游记_汽车生活游记_自驾游记视频_懂车帝',
    keywords: '旅游游记,汽车生活游记,自驾游记视频',
    description:
      '懂车帝自驾游视频频道为您提供国内游记、自驾游游记、出国游记等车友游记笔记，更有各种游记高清图片等您欣赏，看汽车游记，到懂车帝自驾游频道。',
  },
  {
    label: '越野',
    showHome: true,
    path: 'offroad',
    title: '越野车_越野车排行榜_越野车哪个好视频_懂车帝',
    keywords: '越野车,越野车排行榜,越野车哪个好视频',
    description:
      '懂车帝越野车视频频道为广大车友提供最新最全面的越野资讯，越野车排行榜，越野车报价及图片，越野需知等信息，想了解更新更全面的越野车信息，就到懂车帝。',
  },
  {
    label: '改装',
    showHome: true,
    path: 'modification',
    title: '汽车改装_汽车改装知识视频_懂车帝',
    keywords: '汽车改装,改装配件,改装知识视频',
    description:
      '车帝汽车改装视频频道全方位展示改装实战,改装鉴赏,影音改装,改装技术,改装部件等方面的问题。以车会友，尽在懂车帝。',
  },
  {
    label: '学车',
    path: 'learn',
    title: '学车_学车资讯视频_懂车帝',
    keywords: '学车,学车资讯视频',
    description:
      '懂车帝学车资讯视频频道群聚万千车友,交流学车的相关内容。提供最新汽车报价，汽车图片等内容，是提供信息最快最全的中国汽车网站，看车选车买车就上懂车帝。',
  },
  {
    label: '汽车文化',
    path: 'culture',
    title: '汽车生活_游记作文_汽车文化视频_懂车帝',
    keywords: '汽车生活,游记作文,汽车文化视频',
    description:
      '懂车帝汽车文化视频频道为您提供精彩游记,汽车品牌历史,车系历史,经典名车,车坛轶事,汽车生活等最酷最丰富的汽车文化信息。',
  },
  {
    label: '二手车',
    path: 'used',
    title: '二手车交易市场_二手车报价_二手车估价视频_懂车帝',
    keywords: '二手车交易市场,二手车报价,二手车估价视频',
    description:
      '懂车帝二手车视频资讯频道提供最新二手车报价,二手车估价,保值率查询,想了解更多买卖二手车信息就上懂车帝二手车资讯频道。',
  },
  {
    label: '房车',
    path: 'touring',
    title: '房车价格_房车图片_房车品牌大全视频_懂车帝',
    keywords: '房车价格,房车图片,房车品牌大全视频',
    description:
      '懂车帝汇集房车视频资讯频道提供房车价格,房车图片,房车品牌大全,顶级豪华房车,房车改装等专业房车资讯。房车价格及图片,顶级豪华房车价格及图片,最新最全的房车图片及报价,房车大全,尽在懂车帝!',
  },
  {
    label: '赛车',
    path: 'acing',
    title: '赛车_赛车新闻_赛车资讯视频_懂车帝',
    keywords: '赛车,赛车新闻,赛车资讯视频',
    description:
      '懂车帝赛车视频频道为您提供最新赛车动态,评论与访谈,赛程安排。提供最新汽车报价，汽车图片等内容，是提供信息最快最全的中国汽车网站，看车选车买车就上懂车帝。',
  },
  {
    label: '汽车科技',
    path: 'tech',
    title: '最新汽车科技新闻热点事件_最新汽车科技视频排行视频_懂车帝',
    keywords: '最新汽车科技新闻热点事件,最新汽车科技视频排行视频',
    description:
      '懂车帝汽车科技视频频道为您提供最新汽车科技资讯排行，最新汽车科技新闻热点事件，最新汽车科技视频排行，让您实时了解汽车科技动态，了解更多点击懂车帝！',
  },
  {
    label: '技术解读',
    path: 'skill',
    title: '汽车技术解读_汽车技术解析视频_懂车帝',
    keywords: '汽车技术解读,汽车技术解析视频',
    description:
      '懂车帝技术解读视频频道为您提供汽车技术解读资讯内容,这里汇集各大品牌汽车车型技术解读文章和技术解析图片,了解更多汽车技术解读相关内容就来懂车帝。',
  },
]

interface IProps {
  curPath: string
  navList: INavItem[]
  onClick?(text: string): void
}

const TopNav: React.FC<IProps> = ({ curPath, navList, onClick }) => {
  const router = useRouter()
  const isFixedRef = useRef(false)
  const prevAsPathRef = useRef<string>()

  useEffect(() => {
    if (isFixedRef.current && router.asPath !== prevAsPathRef.current) {
      scrollToWithStickyObserve(68)
    }
    prevAsPathRef.current = router.asPath
  }, [router.asPath])

  return (
    <StickyHeader className="tw-mt-20 tw-h-32">
      {(isFixed) => {
        isFixedRef.current = isFixed

        return (
          <OverflowTooltip
            itemCount={navList.length}
            activeIndex={navList.findIndex((d) => d.path === curPath)}
            renderMoreWrapper={(contentCount) => (content) =>
              (
                <div
                  className={classNames('tw-grid tw-p-16', {
                    'tw-grid-cols-1': contentCount === 1,
                    'tw-grid-cols-2': contentCount === 2,
                    'tw-grid-cols-3': contentCount >= 3,
                  })}
                >
                  {content}
                </div>
              )}
            className={classNames(isFixed ? headerHeight : 'tw-h-32')}
          >
            {({ index, isInMore, close, isCover }) => {
              const item = navList[index]
              const isActive = curPath === item.path && !isInMore
              return (
                <div
                  className={classNames(
                    'tw-relative tw-whitespace-nowrap',
                    isInMore
                      ? {
                          'tw-center tw-leading-22 tw-text-center tw-rounded-2 hover:tw-bg-video-light-gray tw-cursor-pointer tw-text-16 xl:tw-text-18':
                            true,
                        }
                      : {
                          'tw-opacity-0': isCover,
                          'tw-inline-flex tw-items-center tw-text-16': true,
                          'tw-text-common-black': isActive || isFixed,
                          'tw-text-18 tw-font-medium': isActive,
                          // 'tw-font-semibold': isActive && isFixed,
                          [style['active']]: isActive,
                          'tw-h-32': !isFixed,
                          'tw-ml-28': !isFixed && index,
                          'tw-ml-40': isFixed && index,
                          'tw-text-common-gray tw-text-16':
                            !isActive && !isFixed,
                        },
                    isFixed && !isInMore ? headerHeight : ''
                  )}
                >
                  <Link
                    href={`/new_video?${serializeObject({
                      topPath: item.path,
                      curPath: item.path,
                    })}`}
                    as={`/video${item.path ? `s/${item.path}` : ''}`}
                    scroll={false}
                  >
                    <a
                      onClick={() => {
                        if (close) close()
                        if (onClick) onClick(item.label)
                      }}
                      className={classNames(style['link'], {
                        'tw-inline-block tw-w-full tw-h-full tw-px-20 tw-py-10':
                          isInMore,
                      })}
                      title={item.label}
                    >
                      {isActive ? <h1>{item.label}</h1> : `${item.label}`}
                    </a>
                  </Link>
                </div>
              )
            }}
          </OverflowTooltip>
        )
      }}
    </StickyHeader>
  )
}

export default TopNav
